module.exports = __webpack_public_path__ + "img/tuijianjigou5.769e1b71.png";